import getConfigurationInfo from '@hooks/configuration/getConfigurationInfo';
import getConfigurationInfoResponse from '@domain/model/response/configuration/getConfigurationInfoResponse';

const useGetConfigurationInfo = (id) => {
    const response = getConfigurationInfo(id);
    const transformedData = getConfigurationInfoResponse(response.data);

    return {
        ...response,
        data: transformedData,
    };
};

export default useGetConfigurationInfo;
